import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SYSTEM_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const INIT_APP = '_INIT_APP';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_MENU_STATE = 'SET_MENU_STATE';
export const SHOW_CONFIRM = '_SHOW_CONFIRM';
export const HIDE_CONFIRM = '_HIDE_CONFIRM';
export const START_LOAD_APP = '_START_LOAD_APP';
export const END_LOAD_APP = '_END_LOAD_APP';
export const UPDATE_PERIOD = '_UPDATE_PERIOD';
export const SET_LOG_LIST = '_SET_LOG_LIST';
export const LOAD_FILE = '_LOAD_FILE';
export const UPLOAD_FILE = '_UPLOAD_FILE';
export const DELETE_FILE = '_DELETE_FILE';
export const LOAD_FILE_BY_URL = '_LOAD_FILE_BY_URL';

export const initApp = createDeferredAction(SYSTEM_MODULE + INIT_APP);

export const setLocale = createDeferredAction(SYSTEM_MODULE + SET_LOCALE, formValues => (formValues));
export const setMenuState = createDeferredAction(SYSTEM_MODULE + SET_MENU_STATE);
export const showGlobalConfirm = createDeferredAction(SYSTEM_MODULE + SHOW_CONFIRM);
export const hideGlobalConfirm = createAction(SYSTEM_MODULE + HIDE_CONFIRM);

export const startLoadApp = createDeferredAction(SYSTEM_MODULE + START_LOAD_APP);
export const endLoadApp = createAction(SYSTEM_MODULE + END_LOAD_APP);
export const setUpdatePeriod = createAction(SYSTEM_MODULE + UPDATE_PERIOD);

export const loadFile = createDeferredAction(SYSTEM_MODULE + LOAD_FILE);
export const loadFileSuccessful = createAction(SYSTEM_MODULE + LOAD_FILE + SUCCESSFUL);
export const loadFileFailed = createAction(SYSTEM_MODULE + LOAD_FILE + FAILED);

export const loadFileByUrl = createDeferredAction(SYSTEM_MODULE + LOAD_FILE_BY_URL);
export const loadFileByUrlSuccessful = createAction(SYSTEM_MODULE + LOAD_FILE_BY_URL + SUCCESSFUL);
export const loadFileByUrlFailed = createAction(SYSTEM_MODULE + LOAD_FILE_BY_URL + FAILED);

export const uploadFile = createDeferredAction(SYSTEM_MODULE + UPLOAD_FILE);
export const uploadFileSuccessful = createAction(SYSTEM_MODULE + UPLOAD_FILE + SUCCESSFUL);
export const uploadFileFailed = createAction(SYSTEM_MODULE + UPLOAD_FILE + FAILED);

export const deleteFile = createDeferredAction(SYSTEM_MODULE + DELETE_FILE);
export const deleteFileSuccessful = createAction(SYSTEM_MODULE + DELETE_FILE + SUCCESSFUL);
export const deleteFileFailed = createAction(SYSTEM_MODULE + DELETE_FILE + FAILED);
